import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  errorMessage: {
    '&:first-letter': {
      textTransform: 'uppercase',
    },
    bottom: theme.spacing(-3),
    position: 'absolute',
    right: 0,
  },
  groupedLabel: {
    color: theme.palette.common.gray600,
  },
  label: {
    '&.required': {
      '&:after': {
        color: 'red',
        content: "' *'",
        display: 'inline',
        marginLeft: theme.spacing(0.5),
        position: 'absolute',
      },
    },
    marginBottom: theme.spacing(0.5),
    position: 'relative',

    textTransform: 'capitalize',
  },
  selector: {
    position: 'relative', // for errorMessage positioning
  },
}));

function getMenuPlacement(menuPlacement, anchorOrigin) {
  switch (menuPlacement) {
    case 'bottom': {
      return {
        marginTop: anchorOrigin,
        top: 0,
      };
    }
    case 'top': {
      return {
        bottom: 0,
        marginBottom: anchorOrigin,
      };
    }
    default: {
      return null;
    }
  }
}

export const inlineSearchSelectWrapperStyles = makeStyles(theme => ({
  arrowIcon: {
    marginLeft: theme.spacing(1),
    transform: props => props.isOpen && 'rotate(180deg)',
    transition: 'transform 250ms linear',
  },
  container: {
    display: 'inline-block',
    position: 'relative',
  },
  styledSelect: props => ({
    position: 'absolute',
    zIndex: theme.zIndex.dropdownMenu,
    ...getMenuPlacement(props.menuPlacement, props.anchorOrigin),
  }),
}));

export default useStyles;
